import br from '@/plugins/i18n/locales/br'
import en from '@/plugins/i18n/locales/en'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// AppBarI18n.vue's language switcher persists the user's choice under the
// SAME localStorage key ('currentLocale') that the `languages` Vuex module
// (languages/updateCurrentLocale) uses for the backend's lang= query param
// — which maps 'br' to 'pt-BR' before saving. Reversing that mapping here is
// what makes a saved choice actually survive a reload: without it this
// always fell back to the literal `locale: 'en'` below, which is why the
// admin could show English card titles next to hardcoded Portuguese menu
// labels in the same screen.
function resolveInitialLocale() {
    const saved = typeof window !== 'undefined' ? window.localStorage.getItem('currentLocale') : null
    if (saved === 'en') return 'en'

    // Covers 'pt-BR', 'br', and the no-preference-yet case — Portuguese is
    // this admin's actual default (see the hardcoded PT-BR strings all over
    // the templates), not the English this file previously always booted to.
    return 'br'
}

export const i18n = new VueI18n({
    locale: resolveInitialLocale(),
    fallbackLocale: 'en',
    messages: { en, br },
})

function setI18nLanguage(lang) {
    i18n.locale = lang

    return lang
}

export function loadLanguageAsync(lang) {
    return Promise.resolve(setI18nLanguage(lang))
}
